import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import IrregularityService from './IrregularityService';

// Actions
const GET_IRREGULARITY = 'irregularities/GET_IRREGULARITY';
const SET_IRREGULARITY = 'irregularities/SET_IRREGULARITY';
const GET_PERSONNEL_IRREGULARITIES = 'irregularities/GET_PERSONNEL_IRREGULARITIES';
const GET_TC_EVENT_IRREGULARITIES = 'irregularities/GET_TC_EVENT_IRREGULARITIES';
const GET_ROOM_IRREGULARITIES = 'irregularities/GET_ROOM_IRREGULARITIES';
const GET_TC_EVENT_REGS = 'irregularities/GET_TC_EVENT_REGS';
const GET_ROOM_REGS = 'irregularities/GET_ROOM_REGS';

const initialState = {
  irregularity: {},
  currentIrregularity: {},
  currentInstitution: {},
  allIrregularities: [],
  eventIrregularities: [],
  roomIrregularities: [],
  errorIrregularity: {},
  tcEventRegs: [],
  roomRegs: [],
};

// Reducer
export default function irregularitiesReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_IRREGULARITY:
      return {
        ...state,
        currentIrregularity: action.result.data,
      };
    case SET_IRREGULARITY:
      return {
        ...state,
        irregularity: action.result.data,
        errorIrregularity: action.result.error || {},
      };
    case GET_PERSONNEL_IRREGULARITIES:
      return {
        ...state,
        allIrregularities: action.result.data,
      };
    case GET_TC_EVENT_IRREGULARITIES:
      return {
        ...state,
        eventIrregularities: action.result.data,
      };
    case GET_ROOM_IRREGULARITIES:
      return {
        ...state,
        roomIrregularities: action.result.data,
      };
    case GET_TC_EVENT_REGS:
      return {
        ...state,
        tcEventRegs: action.result.data || [],
      };
    case GET_ROOM_REGS:
      return {
        ...state,
        roomRegs: action.result.data || [],
      };
    default:
      return state;
  }
}

// Action Creators

export function getIrregularityAction(result) {
  return { type: GET_IRREGULARITY, result };
}

export function setIrregularityAction(result) {
  return { type: SET_IRREGULARITY, result };
}

export function getPersonnelIrregularitiesAction(result) {
  return { type: GET_PERSONNEL_IRREGULARITIES, result };
}

export function getTcEventIrregularitiesAction(result) {
  return { type: GET_TC_EVENT_IRREGULARITIES, result };
}

export function getRoomIrregularitiesAction(result) {
  return { type: GET_ROOM_IRREGULARITIES, result };
}

export function getTcEventRegsAction(result) {
  return { type: GET_TC_EVENT_REGS, result };
}

export function getRoomRegsAction(result) {
  return { type: GET_ROOM_REGS, result };
}


// Action dispatcher functions

export function getIrregularity(id) {
  return createDispatchFunction(
    partial(IrregularityService.getIrregularity, id),
    getIrregularityAction
  );
}

export function setIrregularity(data) {
  return createDispatchFunction(
    partial(IrregularityService.setIrregularity, data),
    setIrregularityAction
  );
}

export function updateIrregularity(data) {
  return createDispatchFunction(
    partial(IrregularityService.updateIrregularity, data),
    setIrregularityAction
  );
}

export function getPersonnelIrregularities(personnelId, params) {
  return createDispatchFunction(
    partial(IrregularityService.getIrregularities, personnelId, params),
    getPersonnelIrregularitiesAction
  );
}

export function getTcEventIrregularities(eventId) {
  return createDispatchFunction(
    partial(IrregularityService.getTcEventIrregularities, eventId),
    getTcEventIrregularitiesAction
  );
}

export function getRoomIrregularities(roomId) {
  return createDispatchFunction(
    partial(IrregularityService.getRoomIrregularities, roomId),
    getRoomIrregularitiesAction
  );
}

export function getTcEventRegs(eventId, orderParam) {
  return createDispatchFunction(
    partial(IrregularityService.getTcEventRegs, eventId, orderParam),
    getTcEventRegsAction
  );
}

export function getRoomRegs(roomId, orderParam) {
  return createDispatchFunction(
    partial(IrregularityService.getRoomRegs, roomId, orderParam),
    getRoomRegsAction
  );
}